




















import Vue from 'vue'

export default Vue.extend({
  name: 'CpSubHeader',
  props: {
    business: {
      type: Boolean,
      default: false,
    },
    displayName: {
      type: String,
      default: '',
    },
  },
  methods: {
    gotoTop() {
      this.$emit('gotoTop')
    },
  },
})
